import { z } from 'zod';

export interface RecipientSuggestion {
  email: string;
  displayName: string | null;
}

export const recipientSuggestionQuerySchema = z.object({
  query: z.string().trim().max(320).optional(),
  limit: z.coerce.number().int().min(1).max(20).optional(),
});

export type RecipientSuggestionQuery = z.infer<typeof recipientSuggestionQuerySchema>;
